import React from 'react';
import ReactDOM from 'react-dom/client';
import './ledger/ledger.css';
import './ledger/ledger-auth.css';
import './index.css';
import App from './App';
import Consent from './Consent';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    // <React.StrictMode>
    <div className="oidcp-container">
        {window.location.pathname === "/consent" ? <Consent/> : <App/>}
    </div>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
